/**
 * ─────────────────────────────────────────────────────────────────────────────
 * After Summit — Centralized Branding Configuration
 * ─────────────────────────────────────────────────────────────────────────────
 *
 * Single source of truth for all user-facing product name and tagline text.
 *
 * Usage:
 *   import { BRANDING } from '@constants/branding'
 *   <title>{BRANDING.APP_NAME} | Dashboard</title>
 *
 * DO NOT put technical identifiers here (localStorage keys, route paths,
 * API names, env vars). Those live in their own constants files and must
 * NOT change when the product name changes.
 * ─────────────────────────────────────────────────────────────────────────────
 */

export const BRANDING = {
  /** Primary product name shown in the UI. */
  APP_NAME: 'After Summit',

  /** Short tagline shown below the logo on auth pages and the loading screen. */
  TAGLINE: 'Co-powered by AgroCast Analytics',

  /** Company / analytics brand used in footers and report exports. */
  COMPANY_NAME: 'After Summit',

  /**
   * Separator used between app name and page name in <title> tags.
   * e.g.  "After Summit | Dashboard"
   */
  TITLE_SEPARATOR: ' | ',

  /** Full copyright line rendered in footers. */
  COPYRIGHT: `© ${new Date().getFullYear()} After Summit. All rights reserved.`,

  /**
   * Builds a browser tab title in the format:
   *   "After Summit | <page>"   — when a page name is provided
   *   "After Summit | Event Management Platform" — base / fallback
   *
   * @param {string} page - The page-specific portion (e.g. "Dashboard")
   * @returns {string}
   */
  pageTitle(page) {
    const suffix = page || 'Event Management Platform'
    return `${this.APP_NAME}${this.TITLE_SEPARATOR}${suffix}`
  },
}
